import { ComponentProps, memo, ReactNode } from 'react'
import cn from 'classnames'

import s from './ModalFooter.module.less'

interface IProps extends ComponentProps<'div'> {
  children: ReactNode
  className?: string
  isSticky?: boolean
}

export const ModalFooter = memo<IProps>(function ModalFooter({ children, className, isSticky, ...rest }) {
  return (
    <div {...rest} className={cn(s.Footer, className, { [s.Footer_sticky]: isSticky })}>
      {children}
    </div>
  )
})
